module.exports = __webpack_public_path__ + "static/media/no_01.d5acd27c.png";